"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StartStreamButton = require("./StartStreamButton");
Object.keys(_StartStreamButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StartStreamButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StartStreamButton[key];
    }
  });
});